import { render } from "./Wheel.vue?vue&type=template&id=94425f92"
import script from "./Wheel.vue?vue&type=script&lang=js"
export * from "./Wheel.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__